import * as local from './local/categories';
import * as nodejs from './nodejs/categories';
import * as laravel from './laravel/categories';

import { API_DRIVER as DRIVER } from '../config/app';

const api = {
    local,
    nodejs,
    laravel
};

export const { list, get, create, update, remove } = api[DRIVER];
